var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.272,
    height: 66.733,
    viewBox: "0 0 67.272 66.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M2.559,15.433,32.265.5l.012-.006a4.677,4.677,0,0,1,4.2.039L49.223,7.242a1.989,1.989,0,0,1,.3.157L64.79,15.438a4.575,4.575,0,0,1,2.483,4.07V47.255a4.575,4.575,0,0,1-2.483,4.07L36.5,66.222l-.013.007a4.677,4.677,0,0,1-4.2.039L2.559,51.33A4.564,4.564,0,0,1,0,47.221V19.541A4.564,4.564,0,0,1,2.559,15.433ZM34.656,4a.7.7,0,0,0-.618-.005L6.232,17.969l10.822,5.345L44.238,9.043ZM36.34,61.879l26.609-14.01.013-.007a.682.682,0,0,0,.371-.607V21.271L36.34,35.234ZM34.349,31.856,61.193,17.969,48.444,11.257l-27.05,14.2ZM3.941,47.221a.68.68,0,0,0,.382.613L32.4,61.947V35.259L19.472,28.875v6.694a1.97,1.97,0,0,1-3.94,0v-8.64L3.941,21.2V47.221Z",
    transform: "translate(0 -0.015)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.37cdfccd67bc9b81d45a4fde0c224f15.svg";
export { ForwardRef as ReactComponent };